import React from 'react'

import EmptyState from '../../../Shared/EmptyState'
import Button from '../../../Shared/Button'

export default function Config({ match }) {
  let { id: actionId } = match.params

  return (
    <EmptyState>
      <Button color="grey" to={`/actions/${actionId}/configure`} icon="edit">
        Edit Configuration
      </Button>
    </EmptyState>
  )
}
